import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Page } from '../../models/page.model';
import { Role } from '../../models/role.model';
import { RoleService } from '../../services/role.service';
import { Utils } from '../../utils';

@Injectable({ providedIn: 'root' })
export class RoleListResolver implements Resolve<Page<Role>> {

    constructor(private roleService: RoleService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Page<Role>>
        | Promise<Page<Role>> | Page<Role> {

        const params = this.prepareParams();

        return this.roleService.getRoleList(params);
    }

    private prepareParams() {
        let params = new HttpParams();

        this.roleService.defaultSort.forEach( param => {
            params = params.append('sort', [param.paramName, param.sortDirection].join(','));
        });

        params = params.append('page', Utils.defaultFirstPage.toString());
        params = params.append('size', Utils.defaultPageSize.toString());

        return params;
    }
}
